import { useScrollReveal } from "@/hooks/useScrollReveal";

const highlights = [
  {
    icon: "ri-drop-line",
    title: "Limpeza de Pele",
    text: "Protocolo completo com ledterapia e máscara personalizada",
  },
  {
    icon: "ri-eye-line",
    title: "Design de Sobrancelhas",
    text: "Design, henna, tintura e brow lamination",
  },
  {
    icon: "ri-home-heart-line",
    title: "Studio Aconchegante",
    text: "Ambiente exclusivo pensado para seu bem-estar",
  },
];

export default function HeroSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="hero" className="relative bg-background-950 overflow-hidden">
      <div className="relative min-h-screen flex items-center">
        <div className="absolute inset-y-0 right-0 w-full lg:w-[58%]">
          <img
            src="https://storage.helloreaddy.io/project_files/070cccc1-78ba-4f09-b9b4-7fe0d725f057/3eeb722d-bfa2-4dcc-841c-0e9369e79847_compressed_IMG_8196.webp"
            alt="Retrato elegante de beleza com iluminação dourada no Jennifer Siqueira Studio de Beleza"
            title="Jennifer Siqueira Studio de Beleza Blumenau"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-950 via-background-950/80 lg:via-background-950/40 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/20 to-background-950/70" />
        </div>

        <div
          ref={ref}
          className={`relative z-10 w-full px-6 md:px-10 pt-32 pb-24 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              <p className="font-label text-[11px] md:text-xs uppercase tracking-[0.35em] text-primary-300 mb-7">
                Studio de Beleza Premium
              </p>
              <h1 className="font-heading text-5xl md:text-7xl lg:text-[5.2rem] font-bold text-background-50 leading-[1.02] mb-7">
                Jennifer Siqueira
                <br />
                <span className="italic font-normal text-primary-200">
                  Studio de Beleza
                </span>
              </h1>
              <p className="text-base md:text-lg text-background-100/75 font-light max-w-lg mb-10 leading-relaxed">
                Transformação que realça sua essência. Tratamentos faciais e
                design de sobrancelhas com excelência, tecnologia e um toque de
                exclusividade.
              </p>
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <a
                  href="https://wa.me/5547991654435?text=Ol%C3%A1%20Jennifer%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio!"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 bg-primary-500 hover:bg-primary-400 text-background-950 px-8 py-4 rounded-md text-[13px] font-label font-medium uppercase tracking-[0.14em] transition-all duration-300 hover:gap-4 whitespace-nowrap cursor-pointer"
                >
                  Agende seu horário
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <a
                  href="#servicos-faciais"
                  className="inline-flex items-center gap-2 text-background-100/80 hover:text-primary-300 font-label text-[13px] uppercase tracking-[0.14em] transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  Ver serviços
                  <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:block">
          <a
            href="#sobre"
            className="flex flex-col items-center gap-2 text-background-100/50 hover:text-primary-300 transition-colors duration-300 cursor-pointer"
          >
            <span className="text-[10px] uppercase tracking-[0.3em] font-label font-light">
              Descubra
            </span>
            <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center animate-bounce"></i>
          </a>
        </div>
      </div>

      <div className="relative z-10 border-t border-primary-500/15">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 divide-y divide-primary-500/15 md:divide-y-0 md:divide-x">
            {highlights.map((item, i) => (
              <div
                key={item.title}
                className={`flex items-start gap-4 py-7 md:py-9 md:px-8 first:md:pl-0 last:md:pr-0 transition-all duration-700 ${
                  isVisible
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-8"
                }`}
                style={{ transitionDelay: `${300 + i * 150}ms` }}
              >
                <span className="w-12 h-12 flex-shrink-0 rounded-full border border-primary-500/30 flex items-center justify-center text-primary-300">
                  <i className={`${item.icon} text-xl w-6 h-6 flex items-center justify-center`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-background-50 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-background-100/60 font-light leading-relaxed">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}